import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllAcademicTerms as apiRestoreAll } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllAcademicTerms() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAllAcademicTerms, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiRestoreAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAllAcademicTerms, isRestore };
}
